const desktop = window.matchMedia("(min-width: 992px)");
if (desktop.matches) {
    var stripeLogo = document.querySelector('.stripe-logo');
    if ( stripeLogo ){
        var disclaimer = document.querySelector('.stripe-disclaimer');
        function showDisclaimer() {
            disclaimer.parentNode.classList.add('show-disclaimer')
        }
        function hideDisclaimer() {
            disclaimer.parentNode.classList.remove('show-disclaimer')
        }
        stripeLogo.onmouseover = showDisclaimer;
        stripeLogo.onmouseleave = hideDisclaimer;
    }
}